if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.titleToShare = this.dataset.shareTitle || document.title;
        this.socialOptions = this.querySelectorAll('.gt-share-option');

        this.bindSocialOptions();

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', async () => {
            try {
              await navigator.share({
                url: this.urlToShare,
                title: this.titleToShare,
              });
            } catch (error) {
              if (error && error.name !== 'AbortError') {
                this.openFallback();
              }
            }
          });
        } else {
          this.bindFallbackControls();
        }
      }

      bindFallbackControls() {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));

        const copyButton = this.mainDetailsToggle.querySelector('.share-button__copy');
        const closeButton = this.mainDetailsToggle.querySelector('.share-button__close');

        if (copyButton) {
          copyButton.addEventListener('click', this.copyToClipboard.bind(this));
        }

        if (closeButton) {
          closeButton.addEventListener('click', this.close.bind(this));
        }
      }

      bindSocialOptions() {
        this.socialOptions.forEach((option) => {
          option.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const pageUrl = this.urlToShare || document.location.href;
            const pageTitle = this.titleToShare || document.title;
            let shareUrl = '';

            if (option.classList.contains('gt-share-option--whatsapp')) {
              shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(`${pageTitle} — ${pageUrl}`)}`;
              this.openShareWindow(shareUrl);
              return;
            }

            if (option.classList.contains('gt-share-option--facebook')) {
              shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
              this.openShareWindow(shareUrl);
              return;
            }

            if (option.classList.contains('gt-share-option--x')) {
              shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(pageTitle)}&url=${encodeURIComponent(pageUrl)}`;
              this.openShareWindow(shareUrl);
              return;
            }

            if (option.classList.contains('gt-share-option--email')) {
              window.location.href = `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(pageUrl)}`;
            }
          });
        });
      }

      openShareWindow(url) {
        const shareWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (shareWindow) {
          shareWindow.opener = null;
        }
      }

      openFallback() {
        if (!this.mainDetailsToggle) return;

        this.mainDetailsToggle.removeAttribute('hidden');
        this.mainDetailsToggle.open = true;

        if (this.elements.shareButton) {
          this.elements.shareButton.classList.add('hidden');
        }

        this.bindFallbackControls();
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          if (this.elements.successMessage) {
            this.elements.successMessage.classList.add('hidden');
            this.elements.successMessage.textContent = '';
          }

          if (this.elements.closeButton) {
            this.elements.closeButton.classList.add('hidden');
          }

          if (this.elements.shareSummary) {
            this.elements.shareSummary.focus();
          }
        }
      }

      async copyToClipboard() {
        const value = this.elements.urlInput ? this.elements.urlInput.value : this.urlToShare;
        let copied = false;

        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(value);
            copied = true;
          } catch (error) {
            copied = false;
          }
        }

        if (!copied && this.elements.urlInput) {
          this.elements.urlInput.removeAttribute('disabled');
          this.elements.urlInput.focus();
          this.elements.urlInput.select();

          try {
            copied = document.execCommand('copy');
          } catch (error) {
            copied = false;
          }
        }

        if (copied && this.elements.successMessage) {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent =
            window.accessibilityStrings?.shareSuccess || 'Link copied';

          if (this.elements.closeButton) {
            this.elements.closeButton.classList.remove('hidden');
            this.elements.closeButton.focus();
          }
        }
      }

      updateUrl(url) {
        this.urlToShare = url;

        if (this.elements.urlInput) {
          this.elements.urlInput.value = url;
        }
      }
    }
  );
}
